"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PushNotificationType = void 0;

/**
 * All push notification types available for iOS
 *
 * @packageDocumentation
 */
var PushNotificationType;
exports.PushNotificationType = PushNotificationType;

(function (PushNotificationType) {
  PushNotificationType["lotOpeningSoon"] = "lotOpeningSoon";
  PushNotificationType["newWorks"] = "newWorks";
  PushNotificationType["newSales"] = "newSales";
  PushNotificationType["outbid"] = "outbid";
  PushNotificationType["promotion"] = "promotion";
  PushNotificationType["purchase"] = "purchase";
  PushNotificationType["saleOpeningClosing"] = "saleOpeningClosing";
})(PushNotificationType || (exports.PushNotificationType = PushNotificationType = {}));